export class ServiceCodesService {
    constructor(axios, apiUrl) {
        this.$axios = axios;
        this.apiUrl = apiUrl;
    }

    async getAllServiceCodes(sqldbid) {
        return await this.$axios.get(
            this.apiUrl + `ServiceCodes/All/${sqldbid}`)
        .then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return {error: error, response: error.response.data };
        });
    }
    
    async getServiceCodesByCodeAndSqldbid(code, sqldbid) {
        return await this.$axios.get(
            this.apiUrl + `ServiceCodes/ServiceCode/${code}/Company/${sqldbid}`)
        .then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return {error: error, response: error.response.data };
        });
    }

    async getServiceCodesAvaliableBySqldbid(avaliable, sqldbid) {
        return await this.$axios.get(
            this.apiUrl + `ServiceCodes/Available/${avaliable}/Company/${sqldbid}`)
        .then(function(response) {
            return response.data;
        })
        .catch(function(error) {
            return {error: error, response: error.response.data };
        });
    }
}
